import {
    Box,
    Button,
    IconButton,
    InputBase,
    Modal,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    useMediaQuery,
  } from "@mui/material";
  import PreviewIcon from "@mui/icons-material/Preview";
  import React, { useEffect, useState } from "react";
  import SearchIcon from "@mui/icons-material/Search";
  import CloseIcon from "@mui/icons-material/Close";
  import axiosWithToken from "../../utils/components/axiosTokenConfig";
  import { BASE_URL } from "../../global";
  import moment from "moment";
  import { Link } from "react-router-dom";
  
  var columns = [
    {
      id: "Client",
      label: "Client",
      align: "center",
      minWidth: 40,
    },
    {
      id: "instrumentName",
      label: "Instrument Name",
      align: "center",
      minWidth: 40,
    },
    {
      id: "DUCID",
      label: "DUCID",
      align: "center",
      minWidth: 40,
    },
    {
      id: "serialNumber",
      label: "Serial Number",
      align: "center",
      minWidth: 40,
    },
    {
      id: "entryDate",
      label: "Inward Date",
      align: "center",
      minWidth: 40,
    },
    {
      id: "calibratedby",
      label: "Calibration Status",
      align: "center",
      minWidth: 40,
    },
    {
      id: "calibrationDate",
      label: "Calibration Date",
      align: "center",
      minWidth: 40,
    },
    {
      id: "approvedby",
      label: "Approved Status",
      align: "center",
      minWidth: 40,
    },
    {
      id: "statusLabel",
      label: "Calibrated By",
      align: "center",
      minWidth: 40,
    },
    {
      id: "statusLabel",
      label: "Approved By",
      align: "center",
      minWidth: 40,
    },
    {
      id: "statusLabel",
      label: "View Certificate",
      align: "center",
      minWidth: 40,
    },
  ];
  
  const DucserialModal = ({ open, onClose, searchTerm: externalSearchTerm, showSearchInput = true }) => {
    const [searchModalOpen, setSearchModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [data, setData] = useState([]);
    const [showMore, setShowMore] = useState(false);
    const isMobile = useMediaQuery("(max-width: 600px)");
    const [userList, setUserList] = useState([]);
    const userType = localStorage.getItem("type");
    const _clientId = localStorage.getItem("clientId");
  
    const handleOpen = () => setSearchModalOpen(true);
    const handleClose = () => {
      setSearchModalOpen(false);
      setShowMore(false);
      setSearchTerm("");
      if (onClose) onClose();
    };

    const effectiveOpen = open !== undefined ? open : searchModalOpen;
    const effectiveSearchTerm = externalSearchTerm !== undefined ? externalSearchTerm : searchTerm;
  
    const fetchDUCANDSerialDate = async (term = effectiveSearchTerm) => {
      if (!term || !term.trim()) return;
      let query = {
        query: `SELECT * FROM certificatesView where ${userType == 3 ? `clientId = ${_clientId} AND ` : ""} (DUCID like '%${term}%' or serialNumber like '%${term}%') and status != -1 order by id DESC`,
      };
  
      axiosWithToken
        .post(BASE_URL + `dynamic`, query)
        .then(async (res) => {
          setData(res.data);
        })
        .catch((err) => {
          console.log(" data fetching error: ", err);
        });
    };
  
    const getUsersList = () => {
      axiosWithToken
        .get(BASE_URL + `users?_where=(status,eq,1)`)
        .then((res) => {
          setUserList(res.data);
        })
        .catch((error) => {
          console.log("Error fetching users list:", error);
        });
    };
  
    useEffect(() => {
      getUsersList();
    }, []);

    useEffect(() => {
        if (effectiveOpen) {
          fetchDUCANDSerialDate(effectiveSearchTerm);
        }
    }, [effectiveOpen, effectiveSearchTerm]);
  
    return (
      <>
        {showSearchInput && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "1px 5px",
                width: "300px",
              }}
            >
              <InputBase
                fullWidth
                sx={{ padding: "2px" }}
                placeholder="Search DUCID or Serial No."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <IconButton
                onClick={() => {
                  handleOpen();
                  fetchDUCANDSerialDate();
                }}
              >
                <SearchIcon color="primary" />
              </IconButton>
            </Box>
          </Box>
        )}
  
        <Modal open={effectiveOpen} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              "@media (max-width: 600px)": {
                width: "80%", // Adjust the width for screens up to 768px wide
              },
              "@media (max-width: 480px)": {
                width: "90%", // Adjust the width for screens up to 480px wide
              },
              // height: 500,
              maxHeight: "calc(100vh - 160px)", // Dynamic max height
              bgcolor: "background.paper",
              border: "2px solid cadetblue",
              padding: "15px 25px",
              textAlign: "center",
              borderRadius: "25px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Close Button (Top-Right) */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 16,
                bgcolor: "#d32f2f",
                "&:hover": { bgcolor: "darkred" },
                height: 25,
                width: 25,
              }}
            >
              <CloseIcon sx={{ color: "white", fontSize: "15px" }} />
            </IconButton>
  
            <br />
  
            {/* <Box sx={{ width: "100%", overflow: "hidden" }}> */}
            <TableContainer sx={{ maxHeight: isMobile ? "85vh" : "65vh" }}>
              <Table
                stickyHeader
                aria-label="sticky table"
                size="small"
                // className="table-responsive"
                sx={{
                  borderCollapse: "collapse",
                  fontSize: "12px",
                  border: "1px solid black",
                }}
              >
                <TableHead>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        padding: "2px 10px",
                        fontSize:"12px"
  
                      }}
                    >
                      <b>{column.label}</b>
                    </TableCell>
                  ))}
                </TableHead>
                <TableBody>
                  {data?.length > 0 ? (
                    (showMore ? data : data?.slice(0, 1))?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {row?.companyName}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {row?.instrumentName}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {row?.DUCID}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {row?.serialNumber}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {row.entryDate &&
                            moment(row.entryDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {row.calibratedby ? "Yes" : "No"}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {row.calibrationDate &&
                            moment(row.calibrationDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {row.approvedby ? "Yes" : "No"}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {userList?.find((user) => user.id == row.calibratedby)
                            ?.userName || ""}
                        </TableCell>
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          {userList?.find((user) => user.id == row.approvedby)
                            ?.userName || ""}
                        </TableCell>
  
                        <TableCell
                          sx={{ border: "1px solid black", padding: "2px 10px", fontSize:"12px" }}
                          align="center"
                        >
                          <Button
                            component={Link}
                            to={`/certificate/viewCertificate/${row.id}`}
                            onClick={handleClose}
                          >
                            <PreviewIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1} align="center">
                        <h6>
                          <b>Data Not Found</b>
                        </h6>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {/* </Box> */}
  
            {/* Show More Button */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
              <Button
                variant="contained"
                size="small"
                disabled={data.length <= 1 || showMore}
                onClick={() => setShowMore((prev) => !prev)}
              >
                Show More
              </Button>
            </Box>
          </Box>
        </Modal>
      </>
    );
  };
  
  export default DucserialModal;